import { QueryBootstrapService } from '@core/services/bootstrap/query-bootstrap.service';
import { Inject } from '@rxdi/core';
import { Component, html } from '@rxdi/lit-html';

/** The app shell: header, routed page, footers. */
@Component({
  selector: 'app-component',
  template() {
    return html`
      <router-outlet>
        <navbar-component slot="header"></navbar-component>
        <rs-site-footer slot="footer"></rs-site-footer>
        <footer-component slot="footer"></footer-component>
      </router-outlet>
    `;
  },
  container: document.body,
})
export class AppComponent extends HTMLElement {
  @Inject(QueryBootstrapService)
  private bootstrap: QueryBootstrapService;

  OnInit() {
    // page-load data in one request; components read it from the cache
    void this.bootstrap.start();

    const loadingElement = document.querySelector('loading-screen-component');
    loadingElement?.remove();
  }
}
